import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/react';
import { publishableKeyFromHost } from '@clerk/react/internal';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
async function startApp() {
  try {
    const response = await fetch('/api/auth/config', { credentials: 'include' });
    if (!response.ok) throw new Error('Login configuration is unavailable.');
    const config = await response.json();
    const clerkPubKey = publishableKeyFromHost(window.location.hostname, config.publishableKey);
    const clerkProxyUrl = config.proxyUrl;
    root.render(
      <ClerkProvider
        publishableKey={clerkPubKey} proxyUrl={clerkProxyUrl}
        signInUrl="/sign-in" signUpUrl="/sign-up"
        appearance={{
          options: { logoImageUrl: `${window.location.origin}/logo.svg`, logoLinkUrl: '/' },
          variables: { colorPrimary: '#004D35', colorForeground: '#0a1a0f', colorMutedForeground: '#58665d', colorBackground: '#ffffff', colorInput: '#ffffff', colorInputForeground: '#0a1a0f', colorDanger: '#b42318', colorNeutral: '#415347', fontFamily: '"Plus Jakarta Sans", sans-serif', borderRadius: '12px' },
          elements: { rootBox: { width: '100%', maxWidth: '100%' }, cardBox: { width: '100%', maxWidth: 440, background: '#fff' } },
        }}
        localization={{
          signIn: { start: { title: 'Welcome back to Viysr', subtitle: 'Sign in to manage your advisor profile' } },
          signUp: { start: { title: 'Create your Viysr account', subtitle: 'Use the email approved for your advisor profile' } },
        }}
      >
        <AuthProvider><App /></AuthProvider>
      </ClerkProvider>
    );
  } catch (_) {
    root.render(<main style={{ padding: 40, fontFamily: 'sans-serif' }}><h1>Viysr is temporarily unavailable</h1><p>We could not load login configuration. Please refresh to try again.</p></main>);
  }
}
startApp();
